import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadFees = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('fees/collection').then((response) => {
            commit(types.ADD_FEES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const createFee = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/fee', data).then((response) => {
            commit(types.ADD_FEE, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
